import { Bar } from "react-chartjs-2";

export function CompletionChart({data}) {
  const chartData = {
    labels: data?.map((item) => item?.name) || [],
    datasets: [
      {
        data: data?.map((item) => item?.completionRate) || [],
        backgroundColor: "#16a34a",
        borderRadius: 8,
        barThickness: 10,
      },
    ],
  };

  const options = {
    indexAxis: "y",
    plugins: { legend: { display: false } },
    scales: {
      x: {
        min: 0,
        max: 100,
        ticks: {
          callback: (val) => val + "%",
        },
        grid: { display: false },
      },
      y: { grid: { display: false } },
    },
  };

  return <Bar data={chartData} options={options} />;
}